// src/components/ui/LanguageToggle.jsx
import { useTranslation } from 'react-i18next';

const LanguageToggle = ({ shortLabels = false, className = '', size = 'md' }) => {
  const { i18n } = useTranslation();

  const setLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const isRu = i18n.language.startsWith('ru');
  const enLabel = shortLabels ? 'EN' : 'English';
  const ruLabel = shortLabels ? 'RU' : 'Русский';
  const isSmall = size === 'sm';
  const containerSizeClass = isSmall ? 'h-[32px] p-0.5 rounded-md' : 'h-[40px] p-1 rounded-lg';
  const indicatorInsetClass = isSmall ? 'top-0.5 bottom-0.5' : 'top-1 bottom-1';
  const indicatorWidthClass = isSmall ? 'w-[calc(50%-2px)]' : 'w-[calc(50%-4px)]';
  const labelSizeClass = isSmall ? 'text-[9px]' : 'text-[10px]';

  return (
    <div
      data-segmented-toggle="true"
      className={`relative w-full bg-slate-800/40 border border-slate-700/30 flex items-center ${containerSizeClass} ${className}`}
    >
      <div
        className={`absolute ${indicatorInsetClass} ${indicatorWidthClass} bg-blue-600 rounded-md transition-all duration-300 ease-in-out shadow-lg shadow-blue-900/10
          ${isRu ? 'translate-x-[100%]' : 'translate-x-0'}`}
      />

      <button
        type="button"
        onClick={() => setLanguage('en')}
        aria-label="English"
        className={`flex-1 relative z-10 ${labelSizeClass} font-bold transition-colors duration-300 uppercase tracking-wider
          ${!isRu ? 'text-white' : 'text-slate-500 hover:text-slate-400'}`}
      >
        {enLabel}
      </button>

      <button
        type="button"
        onClick={() => setLanguage('ru')}
        aria-label="Русский"
        className={`flex-1 relative z-10 ${labelSizeClass} font-bold transition-colors duration-300 uppercase tracking-wider
          ${isRu ? 'text-white' : 'text-slate-500 hover:text-slate-400'}`}
      >
        {ruLabel}
      </button>
    </div>
  );
};

export default LanguageToggle;
